export const congNo = {
  title: 'Receivables',
  titles: {
    list: 'Receivables summary',
    customers: 'Customer receivables',
    invoices: 'Receivables by invoice',
    invoiceLines: 'Debt by document (lines)',
    payments: 'Payments',
    refunds: 'Refunds',
    detail: 'Customer receivables detail',
  },
  fields: {
    invoiceCode: 'Invoice code',
    productCode: 'Item code',
    productName: 'Item name',
    unit: 'Unit',
    quantity: 'Qty',
    unitPrice: 'Unit price',
    lineDiscount: 'Discount',
    lineAmount: 'Amount',
    orderDiscount: 'Order discount',
    otherIncome: 'Other income',
    tax: 'Tax',
    debtAmount: 'Debt',
    voucherCode: 'Document code',
    voucherType: 'Document type',
    customerCode: 'Customer code',
    maNhanVienPhuTrach: 'Sales rep',
    customerName: 'Customer',
    supplierCode: 'Supplier code',
    supplierName: 'Supplier',
    totalReceivable: 'Receivable',
    openingDebt: 'Opening debt',
    invoiceReceivable: 'Invoice receivable',
    invoicePaid: 'Paid on invoices',
    totalPaid: 'Collected',
    totalOtherCost: 'Other costs',
    totalDeduction: 'Deductions',
    totalOpeningAdjust: 'Balance adjustment + opening receivable',
    totalTaxAdvance: 'Tax advance',
    totalRefund: 'Refunds',
    totalSalesReturn: 'Returns',
    balance: 'Outstanding',
    balancePayable: 'Payable',
    phone: 'Phone',
    branch: 'Branch',
    time: 'Time',
    paymentMethod: 'Method',
    amount: 'Amount',
    note: 'Note',
    returnCode: 'Return code',
    refundDue: 'Refund due',
    refundPaid: 'Refunded',
    refundRemain: 'Remaining refund',
    actions: 'Actions',
    dinhMucCongNo: 'Credit limit',
    ngayCanDoiNo: 'Collection date',
    canhBaoCongNo: 'Collection alert',
  },
  canhBao: {
    vuotDinhMuc: 'Over limit',
    quaHan: '{count} days overdue',
    sapDenHan: '{count} days left',
    trongHan: 'Within terms',
    denHanHomNay: 'Due today',
  },
  hanDoiNo: {
    hangThang: 'Day {day} of every month',
    kyNay: 'This period due: {date}',
  },
  list: {
    rowClickExpand: 'Click a row to show or hide receivables detail',
  },
  tabs: {
    customers: 'AR customers',
    invoices: 'AR by invoice',
    invoiceLines: 'AR lines',
    payments: 'Txn payments',
    refunds: 'Txn refunds',
  },
  actions: {
    viewDetail: 'View detail',
    viewReturn: 'View return slip',
    detail: 'Detail',
    exportExcel: 'Export Excel',
    exportAllSheets: 'Export all',
    exportAllSheetsHint: 'Export all 5 sheets: Summary, Invoices, Payments, Refunds, Closing history',
    chot: 'Close period',
    paymentTerms: 'Payment terms',
    chotHistory: 'Close history',
    lock: 'Lock',
    unlock: 'Unlock',
  },
  filter: {
    searchPlaceholder: 'Search by customer name or code',
    searchPlaceholderDon: 'Search by document or customer code',
    searchPlaceholderDonChiTiet: 'Search by document, customer, product code or name',
    searchPlaceholderPayment: 'Search by customer code, name, or note',
    searchPlaceholderRefund: 'Search by customer code, name or note',
    fromDate: 'From date',
    toDate: 'To date',
    textDetailTitle: 'Detailed filters',
  },
  filters: {
    hintSection: 'Tips',
    hintBody: 'Use search to filter by customer or supplier name / code.',
    all: 'All',
    dateSection: 'Period',
    dateRangePlaceholder: 'Select date range',
    fromDate: 'From date',
    toDate: 'To date',
    debtSection: 'Receivable status',
    debtAll: 'All',
    debtOutstanding: 'Outstanding (≠ 0)',
    debtCleared: 'Settled (= 0)',
    canhBaoSection: 'Collection alert',
    canhBaoCanDoi: 'Needs collection (over limit or due)',
    canhBaoVuotDinhMuc: 'Over credit limit',
    canhBaoQuaHan: 'Overdue',
    customerTypeSection: 'Customer type',
    groupSection: 'Customer group',
    voucherTypeInvoice: 'Invoice',
    voucherTypeReturn: 'Return',
    debtRangeSection: 'Outstanding range',
    debtFrom: 'From',
    debtTo: 'To',
    transactionTypeSection: 'Transaction type',
    lockSection: 'Lock status',
    locked: 'Locked',
    unlocked: 'Unlocked',
    sortSection: 'Sort',
    sortField: 'Sort by',
    sortDir: 'Order',
    nhanVienPhuTrachPlaceholder: 'Enter employee code',
  },
  loai: {
    caNhan: 'Individual',
    congTy: 'Organization / household business',
  },
  sort: {
    maKhachHang: 'Customer code',
    tenKhachHang: 'Customer name',
    maHoaDon: 'Invoice code',
    maPhieuTraHang: 'Return code',
    soTien: 'Amount',
    thoiGian: 'Time',
    maNhaCungCap: 'Supplier code',
    tenNhaCungCap: 'Supplier name',
    conNo: 'Outstanding',
  },
  aria: {
    columnPicker: 'Choose visible columns',
  },
  detail: {
    invoiceReturn: 'Returns',
    invoiceRemaining: 'Invoice balance',
    openingBalance: 'Opening balance',
    closingBalance: 'Closing balance',
    tabSummary: 'Summary',
    tabReceivable: 'Invoices',
    tabPayment: 'Payments',
    tabTransaction: 'Entries',
    tabRefund: 'Refunds',
    tabChotHistory: 'Close history',
    rowKindInvoice: 'Invoice',
    rowKindPayment: 'Payment',
    rowKindRefund: 'Refund',
    rowKindTransaction: 'Entry',
    openingAdjust: 'Adj. + opening',
    receivingAccount: 'Receiving account',
    otherCost: 'Other costs',
    deduction: 'Deductions',
    paid: 'Paid',
    taxAdvance: 'Tax advance',
    paymentImages: 'Payment images',
    refundImages: 'Refund images',
    congVaoCongNo: 'Increase debt',
    truDiCongNo: 'Decrease debt',
    notFound: 'Customer not found.',
    loadError: 'Could not load receivables detail.',
    filterInvoiceSearch: 'Search invoice code',
    filterBranchAll: 'All branches',
    filterClear: 'Clear filters',
  },
  transaction: {
    overpayTitle: 'Amount exceeds balance',
    overpayConfirm:
      'The amount {soTien} is greater than the outstanding balance {conNo}. The customer balance will become negative (overpaid). Save anyway?',
    add: 'Add entry',
    create: 'Create receivable entry',
    edit: 'Edit entry',
    date: 'Transaction date & time',
    type: 'Type',
    amount: 'Amount',
    phanBo: {
      title: 'Allocate to invoices',
      hint: 'Auto-fills from oldest to newest. Lock or edit an amount to keep it; the rest keeps auto-allocating.',
      empty: 'No open invoices to allocate.',
      loadFailed: 'Could not load open invoices.',
      lock: 'Lock',
      tongPhanBo: 'Allocated',
      conLai: 'Unallocated',
    },
    description: 'Description',
    runningBalance: 'Balance after',
    deductionCategory: 'Deduction reason',
    images: 'Attachments',
    deleteConfirm: 'Delete this receivable entry?',
    sections: {
      images: 'Received-payment images',
      refundImages: 'Customer refund images',
    },
    canHoanTienChoKhach: 'Refund required for customer',
    soTienNhan: 'Received amount',
    soTienThuHo: 'Collection amount',
    thuHoCho: 'Collect for',
    soTienCanHoan: 'Refund amount',
    congTyNhanTien: 'Receiving account',
    congTyNhanTienPlaceholder: 'Select a company cash/bank account',
    congTyNhanTienHint:
      'Selecting a cash account auto-creates a receipt (type: Payment transaction)',
    taiKhoanChiHoanTien: 'Refund cashbook',
    taiKhoanChiHoanTienPlaceholder: 'Select cashbook to deduct',
    taiKhoanChiHoanTienHint:
      'Required — creates an approved payment voucher and deducts the fund immediately',
    congTyChuyenTien: 'Sending company',
    soTienCanHoanHint: 'Auto: Received − Payment − Collection amount',
    ghiChuHoanTien: 'Refund note',
    refundStatus: 'Refund status',
    refundPartial: 'Partial refund',
    refundDone: 'Refunded',
    refundStatuses: {
      CHUA_HOAN: 'Not refunded',
      HOAN_MOT_PHAN: 'Partial refund',
      DA_HOAN: 'Refunded',
    },
    types: {
      THANH_TOAN: 'Payment',
      HOAN_TIEN: 'Refund',
      CHI_PHI_KHAC: 'Other charge',
      KHAU_TRU: 'Deduction',
      TAM_UNG_THUE: 'Tax advance',
      CAN_BANG: 'Balance adjustment',
      KHOI_TAO: 'Opening balance',
    },
    signedAmountHint: 'Positive increases debt, negative decreases it, and zero is not allowed.',
    deductionCategories: {
      GIAM_GIA: 'Discount',
      HANG_LOI: 'Damaged / defective goods',
      SAI_GIA: 'Price error',
      KHAC: 'Other',
    },
    imagesUpload: {
      pickImage: 'Choose image',
      pasteImage: 'Paste image',
      uploading: 'Uploading...',
      uploadError: 'Upload failed',
      pasteImageNoImage: 'Clipboard has no image.',
      dragDropHint: 'Drag and drop images here or click to choose',
    },
  },
  importKhoiTao: {
    perCustomerHint:
      'An opening balance is accepted only if the date is before every invoice, return, and debt entry of that customer. Positive increases debt, negative decreases it.',
    sampleCode: 'CUSTOMER_CODE',
    open: 'Import opening balance',
    title: 'Import opening receivables',
    description:
      'Excel with 2 columns: customer code and amount (positive increases debt, negative decreases it). Amount must be a whole number (VND). One transaction date for every row.',
    date: 'Opening date & time',
    colCustomerCode: 'Customer code',
    colAmount: 'Amount',
    templateFileName: 'opening-receivables-import-template.xlsx',
    noSheet: 'No sheet found in the Excel file.',
    noData: 'The Excel file has no valid data rows.',
    readError: 'Could not read the Excel file.',
    invalidSummary: '{count} invalid rows. Fix the file and choose it again.',
    errMissingCode: 'Missing customer code',
    errMissingAmount: 'Missing amount',
    errInvalidAmount: 'Invalid amount: {raw}',
    errZeroAmount: 'Amount must not be zero',
    errFractionalAmount: 'Amount must be a whole number (VND), no decimals: {raw}',
    errDuplicate: 'Duplicate customer code in the file',
    hint: 'The date must be before every existing invoice, return, and debt entry. Positive increases debt, negative decreases it.',
    submit: 'Import',
    empty: 'No valid rows.',
  },
  chotAll: {
    open: 'Close all',
    title: 'Close receivables for every customer',
    hint: 'Closes every active customer through the end of the selected day. A closed period locks invoices, returns, and debt entries.',
    submit: 'Close all',
    confirm:
      'Close receivables of all active customers through the end of {date}? Invoices, returns, and debt entries in the period will be locked.',
    resultSummary: 'Closed {ok}/{total} customers. {fail} customers failed:',
  },
  chot: {
    title: 'Close receivables period',
    note: 'Note',
    submit: 'Confirm close',
    closeDate: 'Closing date',
    snapshotHint:
      'Amounts shown are the current balance. The period runs from right after the latest close to the end of the closing date; amounts are calculated automatically.',
    confirm:
      'Close this customer’s receivables through {date}? Invoices, returns and transactions in the period will be locked.',
  },
  chotHistory: {
    title: 'Close history',
    closedAt: 'Closed at',
    period: 'Period',
    note: 'Note',
    cancelled: 'Cancelled',
  },
  paymentTerms: {
    title: 'Update payment terms',
    days: 'Payment days',
  },
  messages: {
    noData: 'No data',
    loadError: 'Could not load receivables list.',
    listSummary: '{count} customer(s) total',
    listSummaryDon: '{count} documents',
    listSummaryDonChiTiet: '{count} lines',
    listSummaryPayment: '{count} debt entries total',
    listSummaryRefund: '{count} refund payment(s) total',
    noTransactions: 'No transactions yet',
    noChotHistory: 'No close history',
    invalidType: 'Invalid entry type.',
    invalidDeductionCategory: 'Select a deduction reason.',
    invalidAmount: 'Invalid amount.',
    invalidDate: 'Select a date.',
    futureDate: 'Transaction date/time cannot be in the future.',
    futureCloseDate: 'Closing date cannot be in the future.',
    amountMustBePositive: 'Amount must be greater than 0.',
    refundFundRequired: 'Refund requires selecting a cashbook for the payment voucher.',
    receivedAmountRequired: 'Enter the received amount.',
    refundAmountRequired: 'Refund amount must be greater than 0 (Received − Payment − Collection).',
    chotSuccess: 'Receivables period closed.',
    chotAllSuccess: 'Closed {ok}/{total} customers.',
    huyChot: 'Undo close',
    huyChotConfirm: 'Undo the latest close? Documents after the previous close date can be edited again.',
    huyChotSuccess: 'Close undone.',
    importSuccess: 'Opening import: {ok} succeeded, {fail} failed.',
    lockSuccess: 'Entry locked.',
    lockConfirm: 'Lock this entry? A locked entry cannot be edited or deleted until unlocked.',
    unlockConfirm: 'Unlock this entry to allow editing / deleting?',
    unlockSuccess: 'Entry unlocked.',
    lockedNeedUnlock: 'This entry is locked — unlock it before editing or deleting.',
  },
}
